module.exports = __webpack_public_path__ + "img/symbol_1.f6fe7f49.png";